/* @flow */
import React, { Component } from 'react';
import TabControl from './impressions-and-views/tab-control.js';
import ImpressionsList from './impressions-and-views/impressions-list.js';
import ViewsList from './impressions-and-views/views-list.js';
import './impressions-and-views.css';

class ImpressionsAndViews extends Component {

  constructor(props) {
    super(props);
    const frames = this.props.cFrames;
    let impressions = [];
    frames.forEach((frame) => {
      frame['item_impressions'].forEach((rec) => {
        const impression = impressions.find((imp) => { return imp.itemId === rec['item_id']; });
        if (!impression)
          impressions.push({ itemId: rec['item_id'], impressionCount: rec['count'], viewCount: 0 });
        else
          impression.impressionCount += rec['count'];
      });
    });
    let views = [];
    frames.forEach((frame) => {
      frame['item_views'].forEach((rec) => {
        const view = views.find((v) => { return v.itemId === rec['item_id']; });
        if (!view)
          views.push({ itemId: rec['item_id'], impressionCount: 0, viewCount: rec['count'] });
        else
          view.viewCount += rec['count'];
        const impression = impressions.find((imp) => { return imp.itemId === rec['item_id']; });
        if (impression)
          impression.viewCount += rec['count'];
      });
    });
    frames.forEach((frame) => {
      frame['item_impressions'].forEach((rec) => {
        const view = views.find((imp) => { return imp.itemId === rec['item_id']; });
        if (view)
          view.impressionCount += rec['count'];
      });
    });
    impressions.sort((a, b) => {
      if (a.impressionCount < b.impressionCount)
        return 1;
      else if (a.impressionCount > b.impressionCount)
        return -1;
      else
        return 0;
    });
    impressions = impressions.slice(0, 12);
    views.sort((a, b) => {
      if (a.viewCount < b.viewCount)
        return 1;
      else if (a.viewCount > b.viewCount)
        return -1;
      else
        return 0;
    });
    views = views.slice(0, 12);
    this.selectImpressions = this.selectImpressions.bind(this);
    this.selectViews = this.selectViews.bind(this);
    this.state = {
      display: 'impressions',
      impressions: impressions,
      views: views,
    };
  }

  selectImpressions(e: SyntheticEvent) {
    e.preventDefault();
    this.setState({ display: 'impressions' });
  }

  selectViews(e: SyntheticEvent) {
    e.preventDefault();
    this.setState({ display: 'views' });
  }

  render() {
    const isImpressions: boolean = this.state.display === 'impressions';
    return (
      <section className="ImpressionsAndViews">
        <header>
          <h2>Item impressions and views</h2>
          <p><strong>Impressions</strong> are the number of times your item has been seen across Folksy, including searches.</p>
          <p><strong>Views</strong> are the number of times someone has chosen to look at your item page.</p>
          <TabControl onImpressionsClick={this.selectImpressions}
                      onViewsClick={this.selectViews}
                      isImpressions={isImpressions}/>
        </header>
        {isImpressions ? (
          <ImpressionsList httpClient={this.props.httpClient} endpoints={this.props.endpoints} impressions={this.state.impressions} />
        ) : (
          <ViewsList httpClient={this.props.httpClient} endpoints={this.props.endpoints} views={this.state.views} />
        )}
        <footer>
          <a href="http://blog.folksy.com/2016/11/15/how-to-boost-sales" target="_blank">
            Read <strong>our tips</strong> for improving your conversion rate
          </a>
        </footer>
      </section>
    );
  }

};

export default ImpressionsAndViews;



// WEBPACK FOOTER //
// ./src/app/stats/container/impressions-and-views.js